<div [formGroup]="form">
  <div class="mb-3 row">
    <div class="col-md-6 row">
      <label for="clienteFormControl" class="col-sm-4 col-form-label"><span
          *ngIf="esCampoVacio(this.clienteFormControl.value)">*</span> Cliente:</label>
      <div class="col-sm-6" style="margin-left: 13px">
        <input  [disabled]="cargandoClientes" id="clienteFormControl" type="text" class="form-control" formControlName="clienteFormControl"
          [inputFormatter]="formatter" [resultFormatter]="formatter" (change)="confirmCustomer()"
          title="Campo obligatorio, debe seleccionar o ingresar un cliente." [ngbTypeahead]="search"
          (selectItem)="selectCustomer($event)" />
        <loading-text-spinner *ngIf="cargandoClientes" [error]="errorClientes" message="Obteniendo clientes..."
          color="primary">
        </loading-text-spinner>

        <div class="alert alert-danger"
          *ngIf="clienteFormControl.invalid && clienteFormControl.errors.required && (clienteFormControl.dirty || clienteFormControl.touched)">
          Requerido
        </div>
      </div>
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-md-6 row">
      <label for="productoFormControl" class="col-sm-4 col-form-label"><span
        *ngIf="esCampoVacio(this.productoFormControl.value)">*</span> Producto:</label>

      <div class="col-sm-6" style="margin-left: 13px" >
        <select [disabled]="obteniendoProductos" class="form-select" id="productoFormControl" name="productoFormControl"
          formControlName="productoFormControl">
          <option [ngValue]="null" defaultSelected>Seleccione un producto</option>
          <option *ngFor="let prod of this.combustibles" [ngValue]="prod">
            {{prod.nombreProducto}}
          </option>
        </select>
        <loading-text-spinner *ngIf="obteniendoProductos" message="Obteniendo productos..."
        color="primary">
      </loading-text-spinner>
        <div class="alert alert-danger"
          *ngIf="productoFormControl.invalid && productoFormControl.errors.required && (productoFormControl.dirty || productoFormControl.touched)">
          Requerido
        </div>
      </div>
    </div>

    <div class="col-md-6 row">
      <label for="volumenFormControl" class="col-sm-4 col-form-label">Volumen por facturar (litros): </label>
      <div class="col-sm-6">
        <input id="volumenFormControl" type="text" class="form-control" formControlName="volumenFormControl"
          appOnlyNumber/>
        <div class="alert alert-danger"
          *ngIf="volumenFormControl.invalid && volumenFormControl.errors.required && (volumenFormControl.dirty || volumenFormControl.touched)">
          Requerido
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 row">
    <div class="col-md-6 row">
      <label class="col-sm-4 col-form-label">Vigencia Hasta:</label>
      <div class="col-sm-4" style="margin-left: 13px">
        <div class="input-group">
          <input type="date" formControlName="fechaHastaFormControl" [(ngModel)]="fechaHasta"
            class="form-control form-control-rounded" ngbDatepicker #d="ngbDatepicker" readonly (click)="d.toggle()">
          <button type="button" class="btn btn-secondary input-group-text" (click)="d.toggle()">
            <i class="fa fa-calendar" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>

  </div>
</div>